import request from '@/utils/request'

// 发布短影音(需要登录)
export function releaseVideo(data) {
  return request({
    url: '/app-api/service/video/releaseVideo/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取当前用户的短影音列表(需要登录)
export function getPresentUserVideoList(query) {
  return request({
    url: '/app-api/service/video/getPresentUserVideoList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 删除视频(仅审核通过才可以删除)
export function deleteVideo(data) {
  return request({
    url: '/app-api/service/video/deleteVideo/v1_0_0',
    method: 'post',
    data: data
  })
}
// 撤回视频(仅待审核可以撤回)
export function returnVideo(data) {
  return request({
    url: '/app-api/service/video/returnVideo/v1_0_0',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/duanyingyin.js